import { render, staticRenderFns } from "./people_session_names.vue?vue&type=template&id=a98bda6e&"
import script from "./people_session_names.vue?vue&type=script&lang=js&"
export * from "./people_session_names.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a98bda6e')) {
      api.createRecord('a98bda6e', component.options)
    } else {
      api.reload('a98bda6e', component.options)
    }
    module.hot.accept("./people_session_names.vue?vue&type=template&id=a98bda6e&", function () {
      api.rerender('a98bda6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/people/people_session_names.vue"
export default component.exports